import {Component, ElementRef, ViewEncapsulation, WritableSignal, signal, InputSignal, input, ChangeDetectionStrategy, viewChild, Signal, EffectRef, effect, untracked, computed, inject} from '@angular/core';
import {SafeHtml} from "@angular/platform-browser";
import {TranslatePipe} from "../../pipes/translate.pipe";
import {TranslateDirective} from "../../directives/translate.directive";

@Component({
    selector: 'app-content',
    imports: [
        TranslatePipe,
        TranslateDirective
    ],
    templateUrl: './content.component.html',
    styleUrl: './content.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContentComponent {
  private hostElement: ElementRef<HTMLElement> = inject(ElementRef<HTMLElement>);

  public textContainer: Signal<ElementRef<HTMLSpanElement> | undefined> = viewChild<ElementRef<HTMLSpanElement>>('textContainer');

  public type: InputSignal<'default' | 'richtext'> = input<'default' | 'richtext'>('default');
  public innerHTML: InputSignal<SafeHtml> = input<SafeHtml>('');
  public expandable: InputSignal<boolean> = input<boolean>(false);
  public fontSize: InputSignal<'fs-1' | 'fs-2' | 'fs-3' | 'fs-4' | 'fs-5' | 'fs-6' | 'fs-normal' | 'fs-small' | 'fs-verysmall' | 'fs-default' | null> = input<'fs-1' | 'fs-2' | 'fs-3' | 'fs-4' | 'fs-5' | 'fs-6' | 'fs-normal' | 'fs-small' | 'fs-verysmall' | 'fs-default' | null>(null);
  public fontColor: InputSignal<'text-muted' | 'text-white' | 'text-primary' | 'text-secondary' | 'text-light' | 'text-danger' | 'text-success' | 'text-warning' | 'text-orange' | 'chat-own-fg' | 'chat-other-fg' | 'chat-other-fg-muted' | 'chat-own-fg-muted' | null> = input<'text-muted' | 'text-white' | 'text-primary' | 'text-secondary' | 'text-light' | 'text-danger' | 'text-success' | 'text-warning' | 'text-orange' | 'chat-own-fg' | 'chat-other-fg' | 'chat-other-fg-muted' | 'chat-own-fg-muted' | null>(null);
  public fontDecoration: InputSignal<'fst-italic' | 'fw-bold' | 'fw-semibold' | null> = input<'fst-italic' | 'fw-bold' | 'fw-semibold' | null>(null);
  // eslint-disable-next-line @angular-eslint/no-input-rename
  public cssClass: InputSignal<string> = input<string>('', {alias: 'class'});

  public richtextClassName: Signal<string> = computed(() => {
    const hostClasses = this.hostElement.nativeElement.className
      .split(/\s+/)
      .filter(token => token && !token.startsWith('ng-'))
      .join(' ');

    return [this.fontSize(), this.fontColor(), this.cssClass(), hostClasses].filter(Boolean).join(' ');
  });

  public isExpanded: WritableSignal<boolean> = signal(false);
  public showReadMore: WritableSignal<boolean> = signal(false);

  private contentChangeEffect: EffectRef = effect(() => {
    if (!this.expandable()) {
      this.isExpanded.set(true);
      this.showReadMore.set(false);
      return;
    }
    if(this.type() === 'richtext' && this.innerHTML()) {
        if (this.textContainer()?.nativeElement) {
          const element = this.textContainer()!.nativeElement;
          untracked(() => {
            this.showReadMore.set(element.scrollHeight > (element.clientHeight * 1.05));
          })
        }
    }
  });

  public expand(): void {
    if (this.expandable()) {
      this.isExpanded.set(true);
    }
  }
}
